export default function getClientes() {
  // onSnapshot(doc(db, database, "clientes"), (doc) => {
  //     var data = Object.values(doc.data())
  //     store.commit('incrementCliente', data)
  // })
}
